import React from 'react';
import { observable, action, computed, toJS } from 'mobx';
import base from '../../tool/base';
import util from '../../util/index';
import { message, Modal, Select, Radio, Popconfirm, InputNumber, Tooltip, Popover } from 'antd';
import constant from '../../components/sys/ecodeDemo/constant';
import findIndex from 'lodash/findIndex';
import isEmpty from 'lodash/isEmpty';

const {
  // typeArr
} = constant;
const { confirm } = Modal;
const Option = Select.Option;
const {
  catchApiError,
  getAccessToken,
  getMobile,
} = util;
message.config({
  top: 20,
});
export class EcodeDemoStore {
  routing = null;
  constructor(routing) {
    this.routing = routing;
  }

  @observable loading = false;
  @observable logList = [];
  @observable count = 0;
  @observable pageNum = 1;
  @observable pageSize = 10;
  @observable searchFormValue = {};
  @observable current = 1;
  @observable activitykey = 'all';
  @observable switchValue = false;
  @observable visibleOfDetail = false;
  @observable judgeLoading = false;
  // @observable detailNum = {};
  @observable detail = {};
  @observable tagData = [];
  @observable visibleOfTag = false;
  @observable addTags = [];
  @observable newTagValue = '';
  @observable newTagDes = '';
  @observable visibleOfNewTag = false;
  @observable editTagId = '';
  @observable editRecord = {};
  @observable searchTagId = [];
  @observable allTag = [];
  @observable currentEditTag = [];
  @observable tagList = [];
  @observable tagSelectedRowKeys = [];
  @observable deletedDemoList = [];
  @observable demoSelectedRowKeys = [];
  @observable updateTagId = '';
  @observable cusLogList = [];
  @observable ecodeRoleList = [];
  @observable visibleOfNewRole = false;
  @observable newMobileValue = '';
  @observable newNameValue = '';
  @observable memberId = '';
  @observable memberLists = [];
  @observable memberselectRowKey = [];
  @observable appmanagerList = [];
  @observable detailConfigVisible = false;
  @observable detailConfigParams = {};
  @observable mainTainerConfigVisible = false;
  @observable currentMainTainer = [];
  @observable searchUsers = [];
  @observable fetching = false;
  @observable releaseConfigVisible = false;
  @observable previewImgList = [];
  @observable imgLoading = false;
  @observable imgChecked = '';
  @observable setPreviewImgLoading = false;
  @observable tabsActiveKey = 'all';
  @observable typeArr = [];
  @observable kbList = [];
  @observable leader = undefined;

  @computed get datas() {
    if (this.activitykey === 'tagmanage') {
      return this.tagList;
    } else if (this.activitykey === 'cusdownloadlog') {
      return this.cusLogList;
    } else if (this.activitykey === 'demorenew') {
      return this.deletedDemoList;
    } else if (this.activitykey === 'ecoderole') {
      return this.ecodeRoleList;
    } else if (this.activitykey === 'memberlist') {
      return this.memberLists;
    } else if (this.activitykey === 'appmanage') {
      return this.appmanagerList;
    }
    return this.logList;
  }

  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach(key => {
      this[key] = params[key];
    });
  }

  @action
  getTabs = () => {
    return [
      { key: 'all', title: '全部' },
      { key: 'success', title: '已通过' },
      { key: 'fail', title: '未通过' },
      { key: 'applying', title: '审核中' },
      { key: 'downloadlog', title: '下载日志' },
      { key: 'tagmanage', title: '标签管理' },
      { key: 'demorenew', title: '案例恢复' },
      { key: 'cusdownloadlog', title: '客户下载日志'},
      { key: 'memberlist', title: '添加协作人'},
      { key: 'ecoderole', title: '协作人管理' }
    ];
  }

  // @action
  // onCell = (detailNum) => {
  //   console.log('detailNum', detailNum);
  //   this.detailNum = detailNum;
  //   this.visibleOfDetail = true;
  // }

  @action
  getColumns = (getInfo = () => {}) => {
    let columns = [];
    if (this.activitykey === 'memberlist'){
      return [
          {
        title: '用户名',
        dataIndex: 'm_name',
        key: 'm_name',
        width: '15%'
      },
        {
          title: '手机号',
          dataIndex: 'm_mobile',
          key: 'm_mobile',
          width: '30%'
        },
        {
          title: '类型',
          dataIndex: 'm_role',
          key: 'm_role',
          width: '15%'
        },
        {
          title: 'id',
          dataIndex: 'm_id',
          key: 'm_id',
          width: '20%'
        },
        {
          title: '操作',
          dataIndex: 'delete',
          key: 'delete',
          width: '20%',
          render: (text, record, index) => {
            let content = null;
            if (!!localStorage.me) {
              let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
              content = (
                  <div>
                    <div style={{ lineHeight: '16px', height: '16px' }}>
                      <a style={{ fontSize: 12 }} onClick={(e) => {
                        confirm({
                          title: `确认添加${record.m_name}吗?`,
                          onOk: () => {
                            let id = record.m_id;
                            this.addEcodeRole(id);
                          },
                        });
                      }}>添加</a>
                    </div>
                  </div>
              );
            }
            return content;
          },
        },
      ]
    } else if (this.activitykey == 'ecoderole'){
      return [
        {
          title: '用户名',
          dataIndex: 'midspan',
          key: 'midspan',
          width: '15%'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          key: 'mobile',
          width: '25%'
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          width: '40%',
          render: (text, record, index) => {
            return (
                <Radio.Group onChange={(v) => this.updateEcodeRole(v, record)} value={record.status}>
                  <Radio value='1'>启用</Radio>
                  <Radio value='0'>禁用</Radio>
                </Radio.Group>
            )
          }
        },
        {
          title: '操作',
          dataIndex: 'delete',
          key: 'delete',
          width: '20%',
          render: (text, record, index) => {
            let content = null;
            if (!!localStorage.me) {
              let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
              content = (
                  <div>
                    <div style={{ lineHeight: '16px', height: '16px' }}>
                      <Popconfirm
                        title={`确认删除${record.midspan}吗?`}
                        okText="确定"
                        cancelText="取消"
                        onConfirm={() => {
                          let id = record.id;
                          this.deleteEcodeRole(id);
                        }}>
                        <a style={{ fontSize: 12 }}>删除</a>
                      </Popconfirm>
                    </div>
                  </div>
              );
            }
            return content;
          },
        },
      ]
    } else if (this.activitykey == 'downloadlog') {
      return [
        {
          title: '案例名称',
          dataIndex: 'title',
          key: 'title',
          width: '20%',
          render: (text, record) => (
            <span className="sys-ecode-table-title" onClick={() => {
              this.visibleOfDetail = true;
              this.detail = record;
            }}>{text}</span>
          )
        },
        {
          title: '用户名',
          dataIndex: 'userName',
          key: 'userName',
          width: '15%',
          render: (text) => {
            if (!text) return text;
            const result = text.split('7')
            if (result[1]) {
              text = result[1];
            }
            if (text.indexOf('`') >= 0) {
              text = text.slice(0, text.indexOf('`'));
            }
            return text;
          }
        },
        {
          title: '公司',
          dataIndex: 'companyName',
          key: 'companyName',
          width: '15%',
        },
        {
          title: '登录ID',
          dataIndex: 'userMobile',
          key: 'userMobile',
          width: '10%',
        },
        {
          title: '下载时间',
          dataIndex: 'createDate',
          key: 'createDate',
          width: '15%',
        },
        {
          title: 'ecode版本',
          dataIndex: 'ecodeVersion',
          key: 'ecodeVersion',
          width: '10%',
        },
        {
          title: 'ecology版本',
          dataIndex: 'ecologyVersion',
          key: 'ecologyVersion',
          width: '15%',
        },
      ]
    } else if (this.activitykey == 'cusdownloadlog') {
      return [
        {
          title: '案例名称',
          dataIndex: 'title',
          key: 'title',
          width: '15%',
        },
        {
          title: '公司名称',
          dataIndex: 'companyName',
          key: 'companyName',
          width: '20%'
        },
        {
          title: 'license',
          dataIndex: 'license',
          key: 'license',
          width: '20%'
        },
        {
          title: '应用发布数',
          dataIndex: 'releaseCount',
          key: 'releaseCount',
          width: '10%'
        },
        {
          title: '发布应用名',
          dataIndex: 'releaseNames',
          key: 'releaseNames',
          width: '20%',
          render: (text, record) => (
            <span className="sys-ecode-release" onClick={() => {
              this.releaseConfigVisible = true;
              this.detail = record;
            }}>{text}</span>
          ),
        },
        {
          title: '下载时间',
          dataIndex: 'createDate',
          key: 'createDate',
          width: '15%'
        }

      ]
    } else if (this.activitykey == 'tagmanage') {
      return [
        {
          title: '标签名',
          dataIndex: 'typeName',
          key: 'typeName',
          width: '10%',
        },
        {
          title: '描述',
          dataIndex: 'description',
          key: 'description',
          width: '75%',
        },
        {
          title: '操作',
          dataIndex: 'delete',
          key: 'delete',
          width: '15%',
          // fixed: 'right',
          render: (text, record, index) => {
            let content = null;
            if (!!localStorage.me) {
              let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
              content = (
                <div>
                  <div style={{ lineHeight: '16px', height: '16px' }}>
                    <a style={{ fontSize: 12 }} onClick={(e) => {
                      this.newTagDes = record.description;
                      this.newTagValue = record.typeName;
                      this.visibleOfNewTag = true;
                      this.updateTagId = record.id;
                    }}>更新</a>
                    <span style={{ fontSize: 18 }}> | </span>
                    <Popconfirm
                        title={`确认删除${record.typeName}吗?`}
                        okText="确定"
                        cancelText="取消"
                        onConfirm={() => {
                          let id = record.id;
                          this.deleteTag(id);
                        }}>
                        <a style={{ fontSize: 12 }}>删除</a>
                    </Popconfirm>
                  </div>
                </div>
              );
            }
            return content;
          },
        },
      ]
    } else if (this.activitykey == 'demorenew') {
      return [
        {
          title: '案例名',
          dataIndex: 'title',
          key: 'title',
          width: '15%',
        },
        {
          title: '账号',
          dataIndex: 'account',
          key: 'account',
          width: '10%',
        },
        {
          title: '公司',
          dataIndex: 'company',
          key: 'company',
          width: '15%',
        },
        {
          title: '用户名',
          dataIndex: 'userName',
          key: 'userName',
          width: '10%',
        },
        {
          title: '详细描述',
          dataIndex: 'description',
          key: 'description',
          width: '14%',
        },
        {
          title: '最新上传时间',
          dataIndex: 'createDate',
          key: 'createDate',
          width: '10%',
        },
        {
          title: '操作',
          dataIndex: 'recover',
          key: 'recover',
          width: '10%',
          // fixed: 'right',
          render: (text, record, index) => {
            let content = null;
            if (!!localStorage.me) {
              let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
              content = (
                <div>
                  <div style={{ lineHeight: '16px', height: '16px' }}>
                    <a style={{ fontSize: 12 }} onClick={(e) => {
                      confirm({
                        title: `确认恢复${record.title}吗?`,
                        onOk: () => {
                          let id = record.id;
                          this.recoverDemo(id);
                        },
                      });
                    }}>恢复</a>
                  </div>
                </div>
              );
            }
            return content;
          },
        },
      ]
    } else if (this.activitykey === 'appmanage') {
      return [
        {
          title: '案例名称',
          dataIndex: 'title',
          key: 'title',
          width: '20%',
          render: (text, record) => (
            <span className="sys-ecode-table-title" onClick={() => {
              this.visibleOfDetail = true;
              this.detail = record;
            }}>{text}</span>
          ),
        },
        {
          title: '用户名',
          dataIndex: 'userName',
          key: 'userName',
          width: '10%',
        },
        {
          title: '部门',
          dataIndex: 'department',
          key: 'department',
          width: '10%',
        },
        {
          title: '分部',
          dataIndex: 'branch',
          key: 'branch',
          width: '10%',
        },
        {
          title: '最新上传时间',
          dataIndex: 'startDate',
          key: 'startDate',
          width: '15%',
          render: (text, record) => (<span>
            <span>{record.modifyDate}<br />{record.modifyTime}</span>
          </span>),
        },
        {
          title: '案例类型',
          dataIndex: 'caseType',
          key: 'caseType',
          width: '10%',
          render: (text, record) => {
            const val = record.attr ? record.attr.caseType : 'case';
            return (
              <Radio.Group value={val} onChange={(e) => this.setCaseType(e.target.value, record)}>
                <Radio value='app'>应用类</Radio>
                <Radio value='case'>案例类</Radio>
              </Radio.Group>
            )
          }
        },
        {
          title: '私有化',
          dataIndex: 'privatisation',
          key: 'privatisation',
          width: '10%',
          render: (text, record) => {
            const val = record.attr ? record.attr.privatisation : 'n';
            return (
              <Radio.Group value={val} onChange={(e) => this.setPrivatisation(e.target.value, record).then((data) => {
                if (data.status) {
                  this.getAppManage();
                }
              })}>
                <Radio value='n'>共享</Radio>
                <Radio value='y'>私有</Radio>
              </Radio.Group>
            )
          }
        },
        {
          title: '价格',
          dataIndex: 'charging',
          key: 'charging',
          width: '10%',
          render: (text, record) => {
            const val = record.attr ? record.attr.charging : 0;
            return (
              <InputNumber
                value={val}
                onBlur={(e) => {
                  this.setCharging(e.target.value, record);
                }}
                formatter={value => `¥ ${value}`}
              />
            )
          }
        },
        {
          title: '是否总部开发',
          dataIndex: 'headquarters',
          key: 'headquarters',
          width: '10%',
          render: (text, record) => {
            const val = record.attr ? record.attr.headquarters : 'y';
            return (
              <Radio.Group value={val} onChange={(e) => this.setHeadQuarters(e.target.value, record)}>
                <Radio value='y'>总部</Radio>
                <Radio value='n'>非总部</Radio>
              </Radio.Group>
            )
          }
        },
      ]
    } else if (this.activitykey === 'privateEcode') {
      return  [
        {
          title: '案例名称',
          dataIndex: 'title',
          key: 'title',
          width: '12%',
          render: (text, record) => (
            <span className="sys-ecode-table-title" onClick={() => {
              this.visibleOfDetail = true;
              this.detail = record;
            }}>{text}</span>
          ),
        },
        {
          title: '用户名',
          dataIndex: 'userName',
          key: 'userName',
          width: '7%',
        },
        {
          title: '详细描述',
          dataIndex: 'description',
          key: 'description',
          width: '16%',
        },
        {
          title: '最新上传时间',
          dataIndex: 'startDate',
          key: 'startDate',
          width: '10%',
          render: (text, record) => (<span>
            <span>{record.modifyDate}<br />{record.modifyTime}</span>
          </span>),
        },
        {
          title: '标签',
          dataIndex: 'tag',
          key: 'tag',
          width: '10%',
          render: (text, record, index) => {
            const tag = record.tag ? record.tag.split(',') : []
            return (
              <Select
                placeholder="请选择标签"
                mode="multiple"
                style={{ width: '100%' }}
                optionLabelProp="label"
                value={tag}
                notFoundContent="无匹配结果"
                bordered={false}
                onChange={(v) => this.handleSelectChange(v, record.id, record)}
              >
                {
                  this.tagData.map(item => {
                    return (<Option label={item.typeName} key={item.id} value={item.typeName}>{item.typeName}</Option>)
                  })
                }
              </Select>
            )
          }
        },
        {
          title: '类型',
          dataIndex: 'demotype',
          key: 'demotype',
          width: '10%',
          render: (text, record, index) => {
            return (
              <Select
                placeholder="请选择类别"
                style={{ width: '100%' }}
                value={text}
                bordered={false}
                onChange={(v) => this.setDemotype(v, record, false)}
                >
                {
                  this.typeArr.map(item => {
                    return (
                      <Option label={item.desc} key={item.demotype} value={item.demotype}>
                        <Popover placement="right" title={item.desc} content={item.info}>
                          {item.desc}
                        </Popover >
                      </Option>)
                  })
                }
              </Select>
            )
          }
        },
        {
          title: '平台',
          dataIndex: 'platform',
          key: 'platform',
          width: '10%',
          render: (text, record) => {
            const tag = record.tag ? record.tag.split(',') : []
            return (
              <Radio.Group onChange={(v) => this.setPlatform(v, record)} value={record.platform}>
                <Radio value='pc'>PC</Radio>
                <Radio value='mobile'>移动端</Radio>
                <Radio value='all'>全部</Radio>
              </Radio.Group>
            )
          }
        },
        {
          title: '状态',
          dataIndex: 'approval',
          key: 'approval',
          width: '7%',
          render: text => (text === 'success' ? '已通过' : text === 'fail' ? '未通过' : '待审核'),
        },
        {
          title: '私有化',
          dataIndex: 'privatisation',
          key: 'privatisation',
          width: '10%',
          render: (text, record) => {
            const val = record.attr ? record.attr.privatisation : 'n';
            return (
              <Radio.Group value={val} onChange={(e) => this.setPrivatisation(e.target.value, record).then((data) => {
                if (data.status) {
                  this.getLogList({}, false);
                }
              })}>
                <Radio value='n'>共享</Radio>
                <Radio value='y'>私有</Radio>
              </Radio.Group>
            )
          }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          width: '15%',
          render: (text, record, index) => {
            let content = null;
            if (!!localStorage.me) {
              content = (
                <div className="sys-ecode-table-operation">
                  {
                    record.approval && this.getApplying(record.approval, record)
                  }
                  <span style={{ fontSize: 12 }} onClick={() => {
                    this.detailConfigVisible = true;
                    this.detail = record;
                    this.detailConfigParams = record;
                    this.leader = record.attr && !isEmpty(record.attr.appDirector) ? record.attr.appDirector : undefined;
                    getInfo(record);
                  }}>详细设置</span>
                  <span style={{ fontSize: 12 }} onClick={() => {
                    this.getMaintainer(record);
                    this.mainTainerConfigVisible = true;
                    this.detailConfigParams = record;
                  }}>维护人</span>
                  <Popconfirm
                    title={`确认删除${record.title}吗?`}
                    okText="确定"
                    cancelText="取消"
                    onConfirm={() => {
                      let id = record.id;
                      this.deleteDemo(id, record);
                    }}>
                    <span style={{ fontSize: 12 }}>删除</span>
                  </Popconfirm>
                </div>
              );
            }
            return content;
          },
        },
      ];
    } else if (this.activitykey === 'all' && this.tabsActiveKey !== 'all') { 
      columns = [
        {
          title: '案例名称',
          dataIndex: 'title',
          key: 'title',
          width: '13%',
          render: (text, record) => (
            <span className="sys-ecode-table-title" onClick={() => {
              this.visibleOfDetail = true;
              this.detail = record;
            }}>{text}</span>
          ),
        },
        {
          title: '用户名',
          dataIndex: 'userName',
          key: 'userName',
          width: '7%',
        },
        {
          title: '详细描述',
          dataIndex: 'description',
          key: 'description',
          width: '17%',
        },
        {
          title: '最新上传时间',
          dataIndex: 'startDate',
          key: 'startDate',
          width: '11%',
          render: (text, record) => (<span>
            <span>{record.modifyDate}<br />{record.modifyTime}</span>
          </span>),
        },
        {
          title: '标签',
          dataIndex: 'tag',
          key: 'tag',
          width: '10%',
          render: (text, record, index) => {
            const tag = record.tag ? record.tag.split(',') : []
            return (
              <Select
                placeholder="请选择标签"
                mode="multiple"
                style={{ width: '100%' }}
                optionLabelProp="label"
                value={tag}
                notFoundContent="无匹配结果"
                bordered={false}
                disabled={this.tabsActiveKey === "commitLog"}
                onChange={(v) => this.handleSelectChange(v, record.id, record)}
              >
                {
                  this.tagData.map(item => {
                    return (<Option label={item.typeName} key={item.id} value={item.typeName}>{item.typeName}</Option>)
                  })
                }
              </Select>
            )
          }
        },
        {
          title: '类别',
          dataIndex: 'demotype',
          key: 'demotype',
          width: '10%',
          render: (text, record, index) => {
            return (
              <Select
                placeholder="请选择类别"
                style={{ width: '100%' }}
                value={text}
                bordered={false}
                disabled={this.tabsActiveKey === "commitLog"}
                onChange={(v) => this.setDemotype(v, record, false)}
                >
                {
                  this.typeArr.map(item => {
                    return (
                      <Option label={item.desc || item.name} key={item.demotype || item.id} value={item.demotype || item.id}>
                        <Tooltip placement="right" title={item.info || item.desc || item.name}><div>{item.desc || item.name}</div></Tooltip>
                      </Option>
                    )
                  })
                }
              </Select>
            )
          }
        },
        (this.activitykey !== "fail" && {
          title: '是否维护',
          dataIndex: 'maintain',
          key: 'maintain',
          width: '6%',
          render: (text = "y", record) => {
            return (
              <Radio.Group value={text} onChange={(e) => this.setMaintain(record.folderId, e.target.value).then((data) => {
                if (data.status) {
                  this.getLogList({}, false);
                }
              })}>
                <Radio value='n'>停止维护</Radio>
                <Radio value='y'>正在维护</Radio>
              </Radio.Group>
            )
          }
        }),
        {
          title: '平台',
          dataIndex: 'platform',
          key: 'platform',
          width: '10%',
          render: (text, record, index) => {
            return (
              <Radio.Group disabled={this.tabsActiveKey === "commitLog"} onChange={(v) => this.setPlatform(v, record)} value={record.platform}>
                <Radio value='pc'>PC</Radio>
                <Radio value='mobile'>移动端</Radio>
                <Radio value='all'>全部</Radio>
              </Radio.Group>
            )
          }
        },
        {
          title: '状态',
          dataIndex: 'approval',
          key: 'approval',
          width: '7%',
          render: text => (text === 'success' ? '已通过' : text === 'fail' ? '未通过' : '待审核'),
        },
      ];
    } else {
      columns = [
        {
          title: '案例名称',
          dataIndex: 'title',
          key: 'title',
          width: '13%',
          render: (text, record) => (
            <span className="sys-ecode-table-title" onClick={() => {
              this.visibleOfDetail = true;
              this.detail = record;
            }}>{text}</span>
          ),
        },
        {
          title: '用户名',
          dataIndex: 'userName',
          key: 'userName',
          width: '7%',
        },
        {
          title: '详细描述',
          dataIndex: 'description',
          key: 'description',
          width: '12%',
        },
        {
          title: '最新上传时间',
          dataIndex: 'startDate',
          key: 'startDate',
          width: '11%',
          render: (text, record) => (<span>
            <span>{record.modifyDate}<br />{record.modifyTime}</span>
          </span>),
        },
        {
          title: '标签',
          dataIndex: 'tag',
          key: 'tag',
          width: '10%',
          render: (text, record, index) => {
            const tag = record.tag ? record.tag.split(',') : []
            return (
              <Select
                placeholder="请选择标签"
                mode="multiple"
                style={{ width: '100%' }}
                optionLabelProp="label"
                value={tag}
                notFoundContent="无匹配结果"
                bordered={false}
                onChange={(v) => this.handleSelectChange(v, record.id, record)}
              >
                {
                  this.tagData.map(item => {
                    return (<Option label={item.typeName} key={item.id} value={item.typeName}>{item.typeName}</Option>)
                  })
                }
              </Select>
            )
          }
        },
        {
          title: '类别',
          dataIndex: 'demotype',
          key: 'demotype',
          width: '10%',
          render: (text, record, index) => {
            return (
              <Select
                placeholder="请选择类别"
                style={{ width: '100%' }}
                value={text}
                bordered={false}
                onChange={(v) => this.setDemotype(v, record)}
              >
                {
                  this.typeArr.map(item => {
                    return (
                      <Option label={item.desc || item.name} key={item.demotype || item.id} value={item.demotype || item.id}>
                        <Tooltip placement="right" title={item.info || item.desc || item.name}><div>{item.desc || item.name}</div></Tooltip>
                      </Option>
                    )
                  })
                }
              </Select>
            )
          }
        },
        {
          title: '平台',
          dataIndex: 'platform',
          key: 'platform',
          width: '6%',
          render: (text, record, index) => {
            const tag = record.tag ? record.tag.split(',') : []
            return (
              <Radio.Group onChange={(v) => this.setPlatform(v, record)} value={record.platform}>
                <Radio value='pc'>PC</Radio>
                <Radio value='mobile'>移动端</Radio>
                <Radio value='all'>全部</Radio>
              </Radio.Group>
            )
          }
        },
        {
          title: '私有化',
          dataIndex: 'privatisation',
          key: 'privatisation',
          width: '6%',
          render: (text, record) => {
            const val = record.attr ? record.attr.privatisation : 'n';
            return (
              <Radio.Group value={val} onChange={(e) => this.setPrivatisation(e.target.value, record).then((data) => {
                if (data.status) {
                  this.getLogList({}, false);
                }
              })}>
                <Radio value='n'>共享</Radio>
                <Radio value='y'>私有</Radio>
              </Radio.Group>
            )
          }
        },
        ((this.activitykey !== "fail" && this.activitykey !== "applying") && {
          title: '是否维护',
          dataIndex: 'maintain',
          key: 'maintain',
          width: '6%',
          render: (text = "y", record) => {
            return (
              <Radio.Group value={text} onChange={(e) => this.setMaintain(record.folderId, e.target.value).then((data) => {
                if (data.status) {
                  this.getLogList({}, false);
                }
              })}>
                <Radio value='n'>停止维护</Radio>
                <Radio value='y'>正在维护</Radio>
              </Radio.Group>
            )
          }
        }),
        {
          title: '状态',
          dataIndex: 'approval',
          key: 'approval',
          width: '7%',
          render: text => (text === 'success' ? '已通过' : text === 'fail' ? '未通过' : '待审核'),
        },
        {
          title: '操作',
          dataIndex: 'download',
          key: 'download',
          width: '15%',
          render: (text, record, index) => {
            let content = null;
            if (!!localStorage.me) {
              let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
              content = (
                <div className="sys-ecode-table-operation">
                  {
                    record.approval && this.getApplying(record.approval, record)
                  }
                  <span style={{ fontSize: 12 }} onClick={() => {
                    this.detailConfigVisible = true;
                    this.detail = record;
                    this.detailConfigParams = record;
                    this.leader = record.user && !isEmpty(record.user) ? {key: record.user.mobile, label: record.user.username} : undefined;
                    getInfo(record);
                  }}>详细设置</span>
                  <span style={{ fontSize: 12 }} onClick={() => {
                    this.getMaintainer(record);
                    this.mainTainerConfigVisible = true;
                    this.detailConfigParams = record;
                  }}>维护人</span>
                  <Popconfirm
                    title={`确认删除${record.title}吗?`}
                    okText="确定"
                    cancelText="取消"
                    onConfirm={() => {
                      let id = record.id;
                      this.deleteDemo(id, record);
                    }}>
                    <span style={{ fontSize: 12 }}>删除</span>
                  </Popconfirm>
                </div>
              );
            }
            return content;
          },
        },
      ];
    }
    return columns.filter(item => item);
  }

  getMaintainer = (record) => {
    const param = {
      folderId: record.folderId,
      access_token: getAccessToken(),
    }
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/getMainTainer', 'GET', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.currentMainTainer = data.data.map(item=>{return { key: item.m_id, label: item.m_name }});
          // message.success("保存成功");
        } else {
          message.error(data.msg || "请求失败");
        }
        this.loading = false;
        resolve(data);
      });
    });
  }

  /**
   * 设置应用是否还在维护
   * @param {String} folderId 应用id
   * @param {Boolean} value 应用是否维护
   * @returns 
   */
  @action
  setMaintain = (folderId, value) => {
    const param = {
      folderId,
      value,
      access_token: getAccessToken(),
    }
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/setMaintain', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          // message.success("保存成功");
        } else {
          message.error(data.msg || "请求失败");
        }
        this.loading = false;
        resolve(data);
      });
    });
  }

  addMaintainer = () => {
    const param = {
      folderId: this.detailConfigParams.folderId,
      mid: this.currentMainTainer.map(item=>item.key).join(','),
      access_token: getAccessToken(),
    }
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/addMainTainer', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          // this.currentMainTainer = data.data;
          this.mainTainerConfigVisible = false;
          message.success("保存成功");
        } else {
          message.error(data.msg || "请求失败");
        }
        this.loading = false;
        resolve(data);
      });
    });
  }

  getUser = (username) => {
    if(!username) return;
    const param = {
      username,
      access_token: getAccessToken(),
    }
    this.fetching = true;
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/getUser', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.searchUsers = data.data;
          // message.success("保存成功");
        } else {
          message.error(data.msg || "查找失败");
        }
        this.fetching = false;
        this.loading = false;
        resolve(data);
      });
    });
  }

  setAppDirector = (params = {}) => {
    params = {
      ...params,
      appId: this.detailConfigParams.folderId,
      access_token: getAccessToken(),
    }
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/setAppDirector', 'POST', params, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
        } else {
          message.error(data.msg || "查找失败");
        }
        resolve(data);
      });
    });
  }

  @action
  setCaseType = (value, record, noFresh) => {
    const param = {
      caseType: value,
      appId: record.folderId,
      mobile: getMobile(),
      access_token: getAccessToken(),
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/setCasetype', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          if (!noFresh) this.getAppManage();
          // message.success("保存成功");
        } else {
          message.error(data.msg || "保存失败");
        }
        this.loading = false;
        resolve(data);
      });
    });
  }

  setPrivatisation = (value, record) => {
    const param = {
      privatisation: value,
      appId: record.folderId,
      mobile: getMobile(),
      access_token: getAccessToken(),
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/setPrivatisation', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          // message.success("保存成功");
        } else {
          message.error(data.msg || "保存失败");
        }
        this.loading = false;
        resolve(data);
      });
    });
  }
  //设置文档是否需要查看权限
  setViewPermission = (value, record) => {
    const param = {
      appId: record.folderId,
      view: value,
      mobile: getMobile(),
      access_token: getAccessToken(),
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/setViewPermission', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          // message.success("保存成功");
        } else {
          message.error(data.msg || "修改失败");
        }
        this.loading = false;
        resolve(data);
      });
    });
  }
  setCharging = (value, record, noFresh) => {
    const param = {
      charging: typeof value === 'string' ? parseFloat(value.slice(2), 10) : value,
      appId: record.folderId,
      mobile: getMobile(),
      access_token: getAccessToken(),
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/charging', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          if (!noFresh) this.getAppManage();
          // message.success("保存成功");
        } else {
          message.error(data.msg || "保存失败");
        }
        this.loading = false;
        resolve(data);
      });
    });
  }

  setViewUrl = (value, record, noFresh) => {
    const param = {
      viewUrl: value,
      privatisation: this.detailConfigParams.privatisation,
      appId: record.folderId,
      mobile: getMobile(),
      access_token: getAccessToken(),
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/setPreViewUrl', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          // if (!noFresh) this.getAppManage();
          // message.success("保存成功");
        } else {
          message.error(data.msg || "保存失败");
        }
        this.loading = false;
        resolve(data);
      });
    });
  }

  setHeadQuarters = (value, record) => {
    const param = {
      headquarters: value,
      appId: record.folderId,
      mobile: getMobile(),
      access_token: getAccessToken(),
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/setRegion', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.getAppManage();
          message.success("保存成功");
        } else {
          message.error(data.msg || "保存失败");
        }
        this.loading = false;
        resolve(data);
      });
    });
  }

  getApplying = (app, record) => {
    let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
    if (app === 'applying') {
      return ([
        <Popconfirm
          key="applyingPass"
          title='确认通过吗?'
          okText="确定"
          cancelText="取消"
          onConfirm={() => {
            let id = record.id;
            this.approvalSuccess(id, me);
          }}>
          <span>通过</span>
        </Popconfirm>,
        <Popconfirm
           key="applyingFail"
           title='确认不通过吗?'
           okText="确定"
           cancelText="取消"
           onConfirm={() => {
             let id = record.id;
             this.approvalFail(id, me);
           }}>
           <span>不通过</span>
         </Popconfirm>
      ]);
    } else if (app === 'success') {
      return (
        <Popconfirm
          title='确认取消共享吗?'
          okText="确定"
          cancelText="取消"
          onConfirm={() => {
            let id = record.id;
            this.approvalFail(id, me);
          }}>
          <span>取消共享</span>
        </Popconfirm>
      )
    } else if (app === 'fail') {
      return (
        <Popconfirm
          title='确认重新发布吗?'
          okText="确定"
          cancelText="取消"
          onConfirm={() => {
            let id = record.id;
            this.approvalSuccess(id, me);
          }}>
          <span>重新发布</span>
        </Popconfirm>
      )
    }
  }

  handleSelectChange = (value, id, record) => {
    this.editTagId = id;
    this.editRecord = record;
    let selectedValue = [];
    value.map(item => {
      this.tagData.map(items => {
        if (items.typeName == item) {
          selectedValue.push(items.id)
        }
      })
    })
    this.addTags = selectedValue;
    this.addTag(this.searchFormValue);
  }

  @action
  init = () => {
    this.searchFormValue = {};
    this.pageNum = 1;
    this.pageSize = 10;
  }

  // 客户下载ecode案例日志接口
  @action
  customerDownloadLog = (params = {}) =>{
    const param = {
      ...params,
      pageNum: params.pageNum || this.pageNum,
      pageSize: params.pageSize || this.pageSize,
    };
    // this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/log/cusDownLoadLog', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.cusLogList = data.data;
          this.count = data.count;
        }
        // this.loading = false;
        resolve(data);
      });
    });
  }


  // 标签管理接口
  @action
  getTag = (params = {}) => {
    const param = {
      pageNum: params.pageNum || this.pageNum,
      pageSize: params.pageSize || this.pageSize,
    };
    // this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/unUsedTag', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.tagList = data.data;
          this.count = data.count;
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        // this.loading = false;
        resolve(data);
      });
    });
  }

  @action
  getAllTags = (id) => {
    const param = {
      demoId: id || ''
    }
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/getAllTags', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.tagData = data.data;
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        resolve(data);
      });
    });
  }

  @action
  getSearchTags = () => {
    const param = {
    }
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/allTags', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.allTag = data.data;
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        resolve(data);
      });
    });
  }

  @action submitTag = (params) => {
    this.addTag(params);
  }

  @action
  setDemotype = (v, record, loading = true) => {
    let me = JSON.parse(localStorage.me);
    const param = {
      demotype: v,
      folderId: record.folderId,
      mobile: me.member.m_mobile || '',
    }
    // this.loading = loading;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/setDemotype', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.getLogList({}, false);
          message.info('设置成功', 1.5);
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        // this.loading = false;
        resolve(data);
      });
    });
  }

  @action
  setPlatform = (v, record, loading = true) => {
    let me = JSON.parse(localStorage.me);
    const param = {
      platform: v.target.value,
      folderId: record.folderId,
      mobile: me.member.m_mobile || '',
    }
    // this.loading = loading;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/setPlatform', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.getLogList({}, false);
          message.info('设置成功', 1.5);
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        // this.loading = false;
        resolve(data);
      });
    });
  }

  @action
  recoverDemo = (id) => {
    const param = {
      demoIds: id || this.demoSelectedRowKeys.join(','),
    }
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/recoverDemo', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.demoSelectedRowKeys = [];
          this.getDeletedDemo();
          message.info('恢复成功', 1.5);
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        resolve(data);
      });
    });
  }

  @action
  deleteTag = (id) => {
    const param = {
      tagIds: id || this.tagSelectedRowKeys.join(','),
    }
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/deleteTag', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.tagSelectedRowKeys = [];
          this.getTag();
          message.info('删除成功', 1.5);
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        resolve(data);
      });
    });
  }

  @action addTag = (params, id) => {
    const param = {
      demoId: this.editTagId,
      tagIds: this.addTags.join(','),
      folderId: this.editRecord.folderId
    }
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/addTag', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.logList = this.logList.map(item => {
            if (item.id == data.data.id) {
              item = data.data;
            }
            return item;
          })
          this.getSearchTags();
          // this.getLogList(params);
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        this.editTagId = '';
        this.editRecord = {};
        this.addTags = [];
        resolve(data);
      });
    });
  }

  @action updateTag = () => {
    const param = {
      tagId: this.updateTagId,
      tagName: this.newTagValue,
      description: this.newTagDes
    }
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/updateTag', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.getTag();
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        this.updateTagId = '';
        this.newTagDes = '';
        this.newTagValue = '';
        resolve(data);
      });
    });
  }

  @action addNewTag = () => {
    const param = {
      typeName: this.newTagValue,
      description: this.newTagDes
    }
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/newTag', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          // this.getAllTags(this.editTagId);
          if (this.activitykey == 'tagmanage') {
            this.getTag();
          } else {
            this.getAllTags();
          }
          // this.getSearchTags();
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        this.newTagDes = '';
        this.newTagValue = '';
        resolve(data);
      });
    });
  }

  @action
  getLogList = (params = {}, loading = true) => {
    let me = JSON.parse(localStorage.me);
    let param = {
      ...this.searchFormValue,
      ...params,
      access_token: getAccessToken(),
      pageNum: params.pageNum || this.pageNum,
      pageSize: params.pageSize || this.pageSize,
      mobile: me.member.m_mobile || '',
      approval: this.activitykey,
      privatisation: 'n'
    };
    if (this.activitykey === 'privateEcode') {
      param['privatisation'] = 'y';
      delete param.approval;
    }
    if (this.activitykey === 'all') {
      switch(this.tabsActiveKey) {
        case "app": 
          param.caseType = 'app';
          break;
        case "mine": 
          param.mine = 'y';
          param.privatisation = 'all';
          break;
        case "commitLog":
          param.mine = "y";
          param.access = "all";
          param.privatisation = 'all';
          break;
        default:
          break;
      }
    }
    this.loading = loading;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/demoList', 'GET', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.logList = data.demoList;
          this.count = data.count;
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        resolve(data);
      });
    });
  }

  @action
  getDeletedDemo = (params = {}) => {
    let me = JSON.parse(localStorage.me);
    const param = {
      ...params,
      pageNum: params.pageNum || this.pageNum,
      pageSize: params.pageSize || this.pageSize,
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/hideDemoList', 'GET', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.deletedDemoList = data.data;
          this.count = data.count;
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        resolve(data);
      });
    });
  }

  @action
  getEcodeLogList = (params = {}) => {
    let me = JSON.parse(localStorage.me);
    const param = {
      ...params,
      access_token: getAccessToken(),
      current: params.current || this.current,
      pageSize: params.pageSize || this.pageSize,
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/log/ecodeLogList', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.logList = data.logs;
          this.count = data.count;
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        resolve(data);
      });
    });
  }

  @action
  getAppManage = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
      pageNum: params.pageNum || this.pageNum,
      pageSize: params.pageSize || this.pageSize,
      mobile: getMobile(),
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/demoList', 'GET', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.appmanagerList = data.demoList;
          this.count = data.count;
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        resolve(data);
      });
    });
  }
  @action
  approvalSuccess = (params = {}) => {
    let me = JSON.parse(localStorage.me);
    const param = {
      ...params,
      access_token: getAccessToken(),
      // pageNum: params.pageNum || this.pageNum,
      mobile: me.member.m_mobile || '',
      ids: params,
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/success', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.logList = data.demoList;
          this.count = data.count;
          message.success("操作成功");
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        this.getLogList(params);
      });
    });
  }

  @action
  approvalFail = (params = {}) => {
    let me = JSON.parse(localStorage.me);
    const param = {
      ...params,
      access_token: getAccessToken(),
      // pageNum: params.pageNum || this.pageNum,
      mobile: me.member.m_mobile || '',
      ids: params,
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/fail', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.logList = data.demoList;
          this.count = data.count;
          message.success("操作成功");
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        this.getLogList(params);
      });
    });
  }

  @action
  approval = (id = "", status = "successful") => {
    const params = {
      id,
      applyStatus: status,
      access_token: getAccessToken(),
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/apply/approval', 'POST', params, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.logList = data.demoList;
          this.count = data.count;
          message.success("操作成功");
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        this.getLogList(params);
      });
    });
  }

  @action
  deleteDemo = (id, record) => {
    const param = {
      access_token: getAccessToken(),
      id,
      folderId: record.folderId,
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/deleteDemo', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.logList = data.demoList;
          this.count = data.count;
          message.success("删除成功");
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        this.getLogList({}, false);
      });
    });
  }

  @action
  mainSwitch = () => {
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/mainSwitch', 'GET', {}, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status) {
          this.switchValue = data.dataValue;
          this.switchDateKey = data.dataKey;
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
      });
    });
  }

  @action
  setSwitch = (v) => {
    let me;
    if (!!localStorage.me) {
      me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
    }
    const param = {
      mobile: me.member.m_mobile,
      dataKey: this.switchDateKey
    }
    if (v) {
      this.switchValue = 'y';
      return new Promise((resolve) => {
        base.callApi('/v5/ecode/openSwitch', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
          if (data.status) {

          } else {
            message.config({
              top: 20,
            });
            message.error(data.msg);
          }
        });
      });
    } else {
      this.switchValue = 'n';
      return new Promise((resolve) => {
        base.callApi('/v5/ecode/closeSwitch', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
          if (data.status) {

          } else {
            message.config({
              top: 20,
            });
            message.error(data.msg);
          }
        });
      });
    }
  }

  @action
  download = (params = {}) => {
    let access_token = getAccessToken();
    let id = params.id;
    let mobile = params.mobile;
    let downloadUrl = "/v5/ecode/download?access_token=" + access_token + "&id=" + id + "&mobile=" + mobile;
    window.location.href = window.server + downloadUrl;
  }

  @action
  initDatas = (key, needInit = true) => {
    if (needInit) {
      this.init();
      this.setMobxState({ searchFormValue: {}, activitykey: key, tagSelectedRowKeys: [] });
    }
    if (key == "downloadlog") {
      this.getEcodeLogList();
    } else if (key == "tagmanage") {
      this.getTag();
    } else if (key == "demorenew") {
      this.getDeletedDemo();
    } else if (key == "cusdownloadlog") {
      this.customerDownloadLog();
    } else if(key == "ecoderole"){
      this.getEcodeRole();
    } else if (key === 'appmanage') {
      this.getAppManage();
    } else if(key == "memberlist"){
      this.getMemberList();
    } else {
      this.getAllTags();
      this.getLogList({ approval: key });
    }
  }

  @action
  getEcodeRole = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
      pageNum: params.current || this.current,
      pageSize: params.pageSize || this.pageSize,
    };

    this.loading = true;
    return new Promise( (resolve) => {
      base.callApi('/v5/ecodeRole/','GET', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status){
          this.ecodeRoleList = data.data;
          this.count = data.count;
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        resolve(data);
      });
    });

  }

  @action
  deleteEcodeRole = (id) => {
    const param = {
      access_token: getAccessToken(),
      ids: id,
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecodeRole/del', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
        if (data.status){
          message.success("删除成功");
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        this.getEcodeRole();
      });
    });
  }

  @action
  updateEcodeRole = (v, record) => {
    const param = {
      access_token: getAccessToken(),
      id : record.id,
      status : v.target.value,
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecodeRole/edit', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
        if (data.status){

        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        this.getEcodeRole();

      });
    });
  }

  @action
  addEcodeRole = (id) => {
    const param = {
      access_token: getAccessToken(),
        mids: id || this.memberselectRowKey.join(','),
    };
    this.loading = true;
    return new Promise((resolve) =>{
      base.callApi('/v5/ecodeRole/insert', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
        if (data.status){
          message.success("添加成功");
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        this.getEcodeRole();
        this.newNameValue = '';
        this.newMobileValue = '';
        resolve(data);
      });
    });
  }

  @action
  getMemberList = (params = {}) => {
    const param = {
      name: '',
      ...params,
      access_token: getAccessToken(),
      pageNum: params.pageNum || this.pageNum,
      pageSize: params.pageSize || this.pageSize,
    };
    this.loading = true;
    return new Promise((resolve) =>{
      base.callApi('/v5/ecodeRole/searchMember', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
        if (data.status){
          this.memberLists = data.List;
          this.count = data.count;
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loading = false;
        resolve(data);
      });
    });
  }

  
  @action
  getImageList = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    };
    this.imgLoading = true;
    base.callApi('/v5/ecode/imageList', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
      if (data.status){
        const imgList = data.data || [];
        this.previewImgList = imgList;
        const checkedIndex = imgList.length > 0 ? findIndex(imgList, {preview: 'y'}) : -1;
        this.imgChecked = checkedIndex > -1 ? imgList[checkedIndex].id : '';
      } else {
        console.error(data.msg);
      }
      this.imgLoading = false;
    });
  }

  @action
  clearImg = () => {
    this.previewImgList = [];
    this.imgChecked = '';
  }
   
  @action
  setPreviewImg = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    };
    this.setPreviewImgLoading = true;
    return new Promise((resolve) =>{
      base.callApi('/v5/ecode/setPreviewImg', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
        if (data.status){
          message.success(data.msg || '修改成功');
        } else {
          console.error(data.msg);
        }
        this.setPreviewImgLoading = false;
        resolve(data);
      });
    });
  }

  @action
  getTypeArr = () => {
    return new Promise((resolve, reject) => {
      try {
        fetch(window.server+'/files/demoType.json')
          .then(function(response) {
            return response.json();
          })
          .then(function(myJson) {
            resolve(myJson);
          });
      } catch(e) {
        console.error(e);
        reject();
      }
    }).then((data) => {
      this.typeArr = data.moduleList || [];
    })
  }

  @action
  getKbList = () => {
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/kbList', 'get', {}, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
        if(data.status) {
          this.kbList = data.data;
        }
        resolve(data);
      });
    })
  }

  @action
  setDemoKb = (params = {}) => {
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/setDemoKb', 'get', params, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
        if(data.status) {
          
        } else {
          message.error(data.msg || "修改失败")
        }
        resolve(data);
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/stores/ecode/ecodeDemoStore.js